import { render, staticRenderFns } from "./field_config.vue?vue&type=template&id=bf032fba&scoped=true"
import script from "./field_config.vue?vue&type=script&lang=js"
export * from "./field_config.vue?vue&type=script&lang=js"
import style0 from "./field_config.vue?vue&type=style&index=0&id=bf032fba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf032fba",
  null
  
)

export default component.exports